import React, { useEffect, useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody, Row, Col, Input, Button, Table } from "reactstrap"
import { FaSearch } from "react-icons/fa"
import { MdPrint } from "react-icons/md"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Loader from "components/Loader/Loader"
import Swal from "sweetalert2"
import Image1 from "../../assets/images/PunchDetails.jpg"
import Logo from "../../assets/images/main-logo.png"
import { usePermissionData } from "AppContext"
import PermittedComponent from "PermittedComponent"

const SalarySlip = () => {
  document.title = "Salary Slip | Vintage Infra Equipment Sol PVT LTD"
  const [loading, setLoading] = useState(false)

  const [employee, setEmployee] = useState("")
  const [month, setMonth] = useState("")
  const [year, setYear] = useState("")
  const [showSlip, setShowSlip] = useState(false)

  const [employees, setEmployees] = useState([])

  useEffect(() => {
    getEmployees()
  }, [])

  async function getEmployees() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setEmployees(APIdata?.data)
    }
  }

  // Dummy salary data (replace with API later)
  const [salaryData, setSalaryData] = useState({})

  const ParsedData = (() => {
    try { return salaryData?.sheet ? JSON.parse(salaryData.sheet) : {} }
    catch { return {} }
  })()

  const gross =
    (salaryData?.basic || 0) + (salaryData?.hra || 0) +
    (salaryData?.conveyance || 0) + (salaryData?.bonus || 0)
  const deductions = (salaryData?.pf || 0) + (salaryData?.tax || 0)
  const netSalary = gross - deductions

  const handleGenerate = async () => {
    const APIdata = await FetchPostData(setLoading, "users/salary/slip", {
      userId: employee,
      month,
      year,
    })
    if (APIdata?.data?.success) {
      setSalaryData(APIdata?.data?.data)
      setShowSlip(true)
    } else {
      Swal.fire({
        title: "Error Fetching Salary Slip",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const handleDownload = () => {
    window.print()
  }

  const { checkAccess } = usePermissionData()

  return (
    <PermittedComponent isAccess={checkAccess(6, "view")}>
      <div className="page-content">
        {loading && <Loader />}
        <Breadcrumb title="Payroll" breadcrumbItem="Salary Slip" />

        {/* Filter Section */}
        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md={2}>
                <Input
                  type="select"
                  className="rounded-4"
                  onChange={e => setEmployee(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {employees?.map((item, index) => (
                    <option value={item?.id} key={index}>
                      {item?.name}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col md={2}>
                <Input
                  type="select"
                  className="rounded-4"
                  onChange={e => setMonth(e.target.value)}
                >
                  <option value="" disabled>
                    Select Month
                  </option>
                  {[
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                  ].map((name, index) => (
                    <option key={index + 1} value={index + 1}>
                      {name}
                    </option>
                  ))}
                </Input>
              </Col>

              <Col md={2}>
                <Input
                  type="select"
                  className="rounded-4"
                  value={year}
                  onChange={e => setYear(e.target.value)}
                >
                  <option value="" disabled>
                    Select Year
                  </option>

                  {Array.from(
                    { length: new Date().getFullYear() - 2025 + 1 },
                    (_, i) => 2025 + i
                  ).map(y => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={2} className="px-0">
                <Button
                  className="btn-blue rounded-4 px-3"
                  disabled={!employee || !month || !year}
                  onClick={handleGenerate}
                >
                  <FaSearch /> Salary Slip
                </Button>
                {showSlip && (
                  <Button
                    color="success"
                    className="rounded-4 ms-3"
                    onClick={handleDownload}
                  >
                    <MdPrint /> Download
                  </Button>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Salary Slip */}
        {showSlip ? (
          <div className="bg-white p-3 mb-4 d-flex justify-content-center">
            <div className="slip " id="salary-slip">
              <div className="logo-row">
                <img src={Logo} className="w-25 object-fit-cover" />
              </div>

              <div className="address-row">
                <p className="mb-0">
                  <strong>
                    Plot No 9 , Shree Dhanraj Industrial Park, Near Tiranga
                    Hotel, Opp Cargo Airport, Uchhali Gam, Ankleshwar -393001,
                    Dist - Bharuch, Gujarat
                  </strong>
                </p>
                <p className="mb-0">
                  <strong>Tel.:</strong> +91 9033658404 &nbsp;&nbsp;
                  <strong>E-mail:</strong>{" "}
                  <a href="mailto:info@viespl.com">info@viespl.com</a>{" "}
                  &nbsp;&nbsp;
                  {/* <strong>Website:</strong> <a href="#">www.zithas.com</a> */}
                </p>
              </div>

              <div className="period-row">
                Pay Slip for the Period of <strong>February – 2026</strong>
              </div>

              <div className="emp-info">
                <div className="emp-left">
                  <div className="emp-row">
                    <span className="lbl">Employee Id</span>
                    <span className="val">
                      : {salaryData?.user?.employeeId}
                    </span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Department</span>
                    <span className="val">: -</span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Date Of Joining</span>
                    <span className="val">
                      : {salaryData?.user?.joiningDate}
                    </span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Bank Acct/Cheque No</span>
                    <span className="val">: N/A</span>
                  </div>
                </div>
                <div className="emp-right">
                  <div className="emp-row">
                    <span className="lbl">Name</span>
                    <span className="val">: {salaryData?.user?.name}</span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Designation</span>
                    <span className="val">
                      : {salaryData?.user?.designation}
                    </span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Leaves</span>
                    <span className="val">
                      : {(ParsedData?.holiday || 0) + (ParsedData?.CL || 0) + (ParsedData?.SL || 0)}
                    </span>
                  </div>
                  <div className="emp-row">
                    <span className="lbl">Days Worked</span>
                    <span className="val">: {ParsedData?.present}</span>
                  </div>
                </div>
              </div>

              <div className="salary-section">
                <div className="earn-col">
                  <div className="col-header">
                    <span>Earnings</span>
                    <span>Amount</span>
                  </div>
                  <div className="salary-row">
                    <span>Total Salary (CTC)</span>
                    <span className="amt">
                      ₹ {Number(ParsedData?.totalSalary || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="salary-row">
                    <span>Travel Expense</span>
                    <span className="amt">
                      ₹{" "}
                      {Number(ParsedData?.detailedExpense?.travel || 0).toFixed(
                        2
                      )}
                    </span>
                  </div>
                  <div className="salary-row">
                    <span>Dearness Allowance</span>
                    <span>
                      ₹{" "}
                      {Number(
                        ParsedData?.detailedExpense?.dearness || 0
                      ).toFixed(2)}
                    </span>
                  </div>
                  <div className="salary-row">
                    <span>Other Expense</span>
                    <span className="amt">
                      ₹{" "}
                      {Number(ParsedData?.detailedExpense?.other || 0).toFixed(
                        2
                      )}
                    </span>
                  </div>
                </div>
                <div className="ded-col">
                  <div className="col-header">
                    <span>Deductions</span>
                    <span>Amount</span>
                  </div>
                  <div className="salary-row">
                    <span className="ded-name">
                      Salary Deduction (Absent Days)
                    </span>
                    <span className="ded-amt">
                      ₹ {Number(ParsedData?.totalDeduction || 0).toFixed(2)}
                    </span>
                  </div>
                  <div className="salary-row">
                    <span className="ded-name">Advance Deduction</span>
                    <span className="ded-amt">
                      ₹ {Number(ParsedData?.totalAdvance || 0).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="total-row">
                <span>Total Earnings</span>
                <span>
                  ₹{" "}
                  {Number(
                    (ParsedData?.totalSalary || 0) + (ParsedData?.totalExpense || 0)
                  ).toFixed(2)}
                </span>
              </div>
              <div className="total-row">
                <span>Total Deductions</span>
                <span>
                  ₹{" "}
                  {Number(
                    (ParsedData?.totalDeduction || 0) + (ParsedData?.totalAdvance || 0)
                  ).toFixed(2)}
                </span>
              </div>
              <div className="net-row">
                <span>Net Pay (Rounded)</span>
                <span>₹ {Number(ParsedData?.finalSalary || 0).toFixed(2)}</span>
              </div>

              <div className="text-center py-3">
                THIS IS A COMPUTER GENERATED SLIP, HENCE SIGNATURE IS NOT
                REQUIRED
              </div>
            </div>
          </div>
        ) : (
          <Card>
            <CardBody className="text-center">
              <img src={Image1} className="object-fit-cover w-25" />
              <h4 className="mt-4">Salary Slip Not Generated Yet.</h4>
            </CardBody>
          </Card>
        )}
      </div>
    </PermittedComponent>
  )
}

export default SalarySlip
